import * as React from "react";
import * as s from "./PulsingDot.css";

type Props = {
  color: string;
  active?: boolean;
  size?: number;
  className?: string;
  style?: React.CSSProperties;
};

/**
 * forwardRef from the start — smart-web hit a real bug where a non-forwardRef
 * version silently broke hover detection when used as a tooltip anchor.
 */
export const PulsingDot = React.forwardRef<HTMLSpanElement, Props>(
  ({ color, active = false, size = 8, className, style }, ref) => (
    <span
      ref={ref}
      className={[s.dot, active ? s.active : null, className].filter(Boolean).join(" ")}
      style={{ width: size, height: size, backgroundColor: color, ...style }}
    />
  ),
);

PulsingDot.displayName = "PulsingDot";
